import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../SessionChecker/SessionChecker";
import Signout from "../Signout/Signout";

export function ProfileMenu({ theme, setProfileMenuStatus, setTheme }) {
  const { sessionStatus, tomanLicence } = useContext(AuthContext);
  const [active, setActive] = useState(false);
  const [ANM, setANM] = useState("");
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [openSignout, setOpenSignout] = useState(false);

  const direction = i18n.language == "fa" ? "rtl" : "ltr";

  useEffect(() => {
    setActive(true);
    theme === "light" ? setANM(false) : setANM(true);
  }, []);

  return (
    <>
      <div
        className={`shadow ${theme}`}
        onClick={() => {
          setActive(false);
          setTimeout(() => {
            setProfileMenuStatus(false);
          }, 150);
        }}
      ></div>
      <div
        className={`popupMainDiv ${theme} ${active && "active"} ${direction == "ltr" ? "ltr" : "rtl"}`}
      >
        {sessionStatus && (
          <>
            {" "}
            {tomanLicence == true && (
              <button
                className={`menuButton ${theme}`}
                onClick={() => {
                  setActive(false);
                  setTimeout(() => {
                    navigate("/interal_accounting");
                  }, 150);
                }}
              >
                <img src="/icons/wallet.png" className={`icon ${theme}`}></img>
                <div>{t("Interal accounting")}</div>
              </button>
            )}

            <button
              className={`menuButton ${theme}`}
              onClick={() => {
                setActive(false);
                setTimeout(() => {
                  navigate("/history/");
                }, 150);
              }} 
            >
              <img src="/icons/history.png" className={`icon ${theme}`}></img>
              <div>{t("History")}</div>
            </button>

            <button
              className={`menuButton ${theme}`}
              onClick={() => {
                setActive(false);
                setTimeout(() => {
                  navigate("/sessions");
                }, 150);
              }}
            >
              <img src="/icons/devices.png" className={`icon ${theme}`}></img>
              <div>{t("Sessions")}</div>
            </button>
            <button
              className={`menuButton ${theme}`}
              onClick={() => {
                setActive(false);
                setTimeout(() => {
                  navigate("/edit_profile");
                }, 150);
              }}
            >
              <img src="/icons/profile.png" className={`icon ${theme}`}></img>
              <div>{t("Edit profile")}</div>
            </button>
            <button
              className={`menuButton ${theme}`}
              onClick={() => {
                setActive(false);
                setTimeout(() => {
                  navigate("/authentication");
                }, 150);
              }}
            >
              <img
                src="/icons/authentication.png"
                className={`icon ${theme}`}
              ></img>
              <div>{t("Authentication")}</div>
            </button>{" "}
          </>
        )}

        <button
          className={`menuButton ${theme}`}
          onClick={() => {
            setActive(false);
            setTimeout(() => {
              navigate("/languages");
            }, 150);
          }}
        >
          <img src="/icons/languages.png" className={`icon ${theme}`}></img>
          <div>{t("Language")}</div>
          <div className="center_div"></div>
        </button>

        <button
          className={`menuButton ${theme}`}
          onClick={() => {
            setActive(false);
            setTimeout(() => {
              navigate("/licenses");
            }, 150);
          }}
        >
          <img src="/icons/note.png"></img>
          <div>{t("Licenses")}</div>
        </button>

        <button
          className={`menuButton ${theme}`}
          onClick={() => {
            setTheme(theme === "light" ? "night" : "light");
            setANM(!ANM);
          }}
        >
          <img src="/icons/moon.png" className={`icon ${theme}`}></img>
          <div>{t("Night mode")}</div>
          <div className="center_div"></div>
          <div className={`activation_div`}>
            <div
              className={`activation_icon ${theme === "night" ? "active" : ""} ${ANM ? "active" : ""}`}
            ></div>
          </div>
        </button>

        {sessionStatus && (
          <>
            <button
              className={`menuButton ${theme}`}
              onClick={() => {
                setOpenSignout(true);
              }}
            >
              <img src="/icons/signout.png"></img>
              <div>{t("Signout")}</div>
            </button>

            {openSignout && (
              <Signout
                theme={theme}
                setOpenSignout={setOpenSignout}
              ></Signout>
            )}
          </>
        )}
      </div>
    </>
  );
}
